import React from "react";

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-[#dedbd4] bg-white mt-16 py-8 text-xs text-[#62666b]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-[#1b2a47]">LegalEase</span>
            <span className="text-[#dedbd4]">|</span>
            <span>Jogi Munkafolyamatok</span>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-[#f3f1ec] flex flex-col sm:flex-row items-center justify-between gap-2 text-[#8c8982] text-[11px]">
          <p>© {currentYear} LegalEase (Watt Mind). Minden jog fenntartva.</p>
          <p>Bizalmas és biztonságos ügyvédi infrastruktúra.</p>
        </div>
      </div>
    </footer>
  );
};
